import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCM9Zym2OKiobk8JQN2Af1bCdvqz8jlTWs',
  authDomain: 'aarnastores-64786.firebaseapp.com',
  databaseURL: 'https://aarnastores-64786-default-rtdb.firebaseio.com',
  projectId: 'aarnastores-64786',
  storageBucket: 'aarnastores-64786.firebasestorage.app',
  messagingSenderId: '693368537283',
  appId: '1:693368537283:web:1e271a26cc15010f116276',
  measurementId: 'G-7RLS9ZKGVP',
};

let app;
let db = null;
let auth = null;

try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  console.error('Firebase init failed:', error.message);
}

if (app) {
  try { db = getDatabase(app); } catch (e) { console.error('DB init failed:', e.message); }
  try { auth = getAuth(app); } catch (e) { console.error('Auth init failed:', e.message); }
}

export { db, auth };
